import { post, } from "../helpers/apiHelper";

async function searchProducts(params) {    
    return await post(`products`, params);
}

export default {
    searchProducts
}